import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Injectable } from '@angular/core';
import { ApiService } from '../../../services/api/api.service';
import { mergeMap } from 'rxjs/operators';
import { GetBijbEventsAction } from '../../actions/bijb-event/get-events-action';
import { GetBijbEventsSuccessAction } from '../../actions/bijb-event/get-events-success-action';
import { GetBijbEventsErrorAction } from '../../actions/bijb-event/get-events-error-action';

@Injectable()
export class GetBijbEventsEffect {
  constructor(private api: ApiService, private actions: Actions) {
  }


  public GetEventsActions = createEffect(() => this.actions
    .pipe(
      ofType(GetBijbEventsAction.type),
      mergeMap(() => {
        return this.api.getEvents().then(events => {
          events.sort((a, b) => {
            if (a.datumVanEvent && b.datumVanEvent) {
              return a.datumVanEvent.unix() - b.datumVanEvent.unix();
            } else if (a.datumVanEvent) {
              return -1;
            } else if (b.datumVanEvent) {
              return 1;
            } else {
              return a.naam.localeCompare(b.naam);
            }
          });
          return new GetBijbEventsSuccessAction(events);
        }, error => {
          return new GetBijbEventsErrorAction(error);
        });
      })
    ));
}
